import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { heroSocials, heroStats } from '../data/heroStats';
import { INTRO, lineRise } from '../utils/reveal';
import { useIsMobile } from '../hooks/useIsMobile';

/**
 * Bottom row of the hero, just above the showreel: proof point (left) and social links (right).
 * Each item is its own clip mask (for the rise-in) and is marked `data-drone-push`, so a hypnotised
 * Pixel can knock it about.
 */
export function StatsRow() {
  const reduce = useReducedMotion();
  const mobile = useIsMobile();
  return (
    // Mobile: centred stack with a little more air between tagline and socials; desktop: one row
    <div className="grid grid-cols-1 justify-items-center gap-4 px-3 text-center text-base md:text-[clamp(0.875rem,1.05vw,1.25rem)] font-bold leading-tight tracking-[-0.03em] text-black md:grid-cols-2 md:justify-items-start md:gap-1 md:px-[1.6vw] md:text-left" data-id="element-211" data-mp="3s15xuqquvkmx">
      <ul aria-label="Results" className="contents" data-id="element-212" data-mp="34bts60uqlupd">
        {heroStats.map((stat, i) =>
        // Each item rises up out of its own line on page load, left → center → right
        <li key={stat} data-drone-push
        // Mobile: the tagline sits under the logo instead (HeroSection), so only the socials stay here
        className={`hidden w-fit overflow-hidden pb-[0.12em] md:block ${i === 1 ? 'md:justify-self-center' : ''}`} data-id="element-213" data-mp="3c32l9d7utsub" data-mpi={i}>
            <motion.span className="block" {...lineRise(INTRO.stats + i * INTRO.stat, reduce)} data-id="element-214" data-mp="2xe6j1wshba1m">
              {stat}
            </motion.span>
          </li>)}
      </ul>

      <nav aria-label="Social" data-drone-push className="w-fit overflow-hidden pb-[0.12em] md:justify-self-end" data-id="element-215" data-mp="2obx9pa8y5mpt">
        {/* Phones: first in the bottom-up intro */}
        <motion.p key={mobile ? 'm' : 'd'} className="block" {...mobile ? {} : lineRise(INTRO.stats + heroStats.length * INTRO.stat, reduce)} data-id="element-216" data-mp="2jfoxa4m4w7mc">
          {heroSocials.map((link, i) => <React.Fragment key={link.label} data-id="element-217" data-mp="10q2j3t6jx3yh" data-mpi={i}>
              {i > 0 && <span aria-hidden="true" className="px-[0.6em] text-neutral-400" data-id="element-218" data-mp="15has4o3yynb4">
                  /
                </span>}
              <a href={link.href} target="_blank" rel="noopener noreferrer" className="pointer-events-auto rounded-sm transition-opacity duration-200 ease-out hover:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black" data-id="element-219" data-mp="rqyy2jntqehc">
                {link.label}
              </a>
            </React.Fragment>)}
        </motion.p>
      </nav>
    </div>
  );
}